import {
  SectionElement,
  defineElement,
  query
} from "./chunk-DNDL4K7L.js";
import {
  __decorateClass
} from "./chunk-RGTSXKO2.js";

// src/sections/shop-newsletter-popup/shop-newsletter-popup.ts
var ShopNewsletterPopup = class extends SectionElement {
  connectedCallback() {
    var _a, _b;
    document.addEventListener("DOMContentLoaded", () => {
      const queryString = window.location.search;
      if (queryString.includes("customer_posted=true")) {
        this.successPopover.open();
      }
    });
    (_a = this.successPopover.querySelector("[close-btn]")) == null ? void 0 : _a.addEventListener("click", () => this.resetUrlParams());
    (_b = this.successPopover.querySelector("[data-bg-close]")) == null ? void 0 : _b.addEventListener("click", () => this.resetUrlParams());
  }
  resetUrlParams() {
    const params = new URLSearchParams(window.location.search);
    params.delete("customer_posted");
    location.replace(window.location.pathname + "?" + params);
  }
};
__decorateClass([
  query("[successful-registration-popover]")
], ShopNewsletterPopup.prototype, "successPopover", 2);
ShopNewsletterPopup = __decorateClass([
  defineElement("shop-newsletter-popup")
], ShopNewsletterPopup);
export {
  ShopNewsletterPopup
};
